{
	"title": "Timed results",
	"columns": {
		"lane": "Lane",
		"bib": "Bib",
		"competitor": "Competitor",
		"reaction": "Reaction",
		"splitAt": "{{distance}} m",
		"splitN": "Split {{n}}",
		"time": "Time",
		"behind": "Behind",
		"final": "Final Time",
		"timeBehind": "Time Behind",
		"irm": "IRM",
		"records": "Records",
		"points": "Points",
		"laps": "Laps",
		"speed": "km/h",
		"rank": "Rank",
		"qualification": "Q",
		"qualificationLong": "Qualification",
		"state": "State",
		"source": "Source",
		"timer": "Timer",
		"timerLong": "The pool timer's latest reading for this lane. Not saved until you apply it.",
		"place": "Place",
		"lapsDelta": "Laps +/−",
		"sprints": "Sprints",
		"ride": "Race {{n}}",
		"decider": "Decider",
		"timerLongTrack": "The track timer's latest reading for this lane. Not saved until you apply it."
	},
	"aria": {
		"grid": "Results of {{meet}}",
		"reaction": "Reaction time, {{name}}",
		"split": "Split at {{split}}, {{name}}",
		"time": "Time, {{name}}",
		"irm": "Invalid result mark, {{name}}",
		"records": "Records, {{name}}",
		"laps": "Laps, {{name}}",
		"speed": "Speed in km/h, {{name}}",
		"place": "Finishing place, {{name}}",
		"lapsDelta": "Laps gained or lost, {{name}}",
		"sprints": "Points at each sprint, {{name}}",
		"ride": "Race {{n}} of the match, {{name}}",
		"showLegs": "Show the legs of {{name}}",
		"hideLegs": "Hide the legs of {{name}}",
		"legMember": "Athlete for leg {{n}}",
		"legReaction": "Take-off for leg {{n}}",
		"legSplit": "Leg time for leg {{n}}",
		"override": "Override the timing result of {{name}}",
		"relock": "Give {{name}} back to the timing result"
	},
	"irmNone": "None",
	"parse": {
		"timeFormat": "Not a time. Type digits only, for example 5231 for 52.31.",
		"numberFormat": "Not a number.",
		"ride": "Type W (won), L (lost) or the winner's time.",
		"range": "Out of range for this field.",
		"precision": "Too many decimals for this event.",
		"unknown": "Not a mark. Use DNS, DNF or DSQ.",
		"notAllowed": "That mark is not used in timed events.",
		"order": "Each split must be later than the one before.",
		"needsPrevious": "Enter the split before this one first.",
		"recordFormat": "Use record codes such as GR or NR.",
		"recordRepeat": "A record is listed twice.",
		"recordTooMany": "At most {{max}} records."
	},
	"toolbar": {
		"sortLabel": "Order by",
		"sortLane": "Lane",
		"sortResult": "Result",
		"resort": "Re-sort",
		"settings": "Settings",
		"heldHint": "The order is held while you type.",
		"options": "Columns and entry",
		"splitsEvery": "Split columns",
		"splitsNone": "Only saved splits",
		"splitsEveryValue": "Every {{distance}} m",
		"splitEntry": "Type splits as",
		"cumulative": "Running time",
		"lap": "Lap time",
		"precision": "Timed to",
		"hundredths": "0.01 s",
		"thousandths": "0.001 s"
	},
	"settings": {
		"distance": "Distance",
		"distanceValue": "{{distance}} m",
		"distanceUnit": "m",
		"distanceAria": "Race distance in metres",
		"distanceRange": "A distance is whole metres, 1 to 100,000.",
		"distanceSaved": "Distance saved",
		"distanceFromEvent": "From the event name. Type to set this meet's own.",
		"distanceNone": "Not set: no split columns until it is.",
		"legs": "Legs",
		"wind": "Wind",
		"windUnit": "m/s",
		"windAria": "Wind reading in metres per second",
		"windRange": "Wind must be between −20 and 20 m/s, one decimal.",
		"windSaved": "Wind saved",
		"windNone": "No reading"
	},
	"row": {
		"provisionalQ_one": "Provisional: the fastest across all heats. Confirmed when the round advances.",
		"provisionalQ_other": "Provisional: in the top {{count}} across all heats. Confirmed when the round advances.",
		"provisionalPlace_one": "Provisional Q: first in this heat. Confirmed when the round advances.",
		"provisionalPlace_other": "Provisional Q: in the first {{count}} of this heat. Confirmed when the round advances.",
		"provisionalTime_one": "Provisional q: the fastest of the rest across all heats. Confirmed when the round advances.",
		"provisionalTime_other": "Provisional q: among the {{count}} fastest of the rest across all heats. Confirmed when the round advances.",
		"waiting": "Waits for: {{source}}",
		"sourceWinner": "Winner of {{meet}}",
		"sourceLoser": "Loser of {{meet}}",
		"sourceMeetRank": "Rank {{rank}} in {{meet}}",
		"sourcePhaseRank": "Rank {{rank}} from the previous phase",
		"sourcePoolRank": "Rank {{rank}} in pool {{pool}}",
		"restored": "From this device",
		"willRetry": "Will retry",
		"rankNotSaved": "Rank not saved yet",
		"finalBeforeSplit": "The time is earlier than the last split, so the finish split is not saved.",
		"conflictBody": "Someone else saved this row. Choose which result to keep.",
		"loadingTheirs": "Loading their version…",
		"theirs": "Theirs",
		"mine": "Mine",
		"noResult": "No result"
	},
	"refused": {
		"official": "The meet is official. To change results, change the Meet status (you will be asked to confirm).",
		"locked": "The medal desk has locked this event.",
		"field": "Some values were not accepted.",
		"not_found": "This slot is no longer in the meet. Check the start list.",
		"forbidden": "Your role cannot enter results.",
		"conflict": "The server refused this row.",
		"unknown": "The server refused this row. Try again.",
		"fieldLine": "{{field}}: check this value.",
		"fields": {
			"time": "Time",
			"irm": "IRM",
			"records": "Records",
			"rank": "Rank",
			"points": "Points",
			"splits": "Splits",
			"reaction": "Reaction",
			"laps": "Laps",
			"speed": "Speed",
			"row": "Row"
		}
	},
	"relay": {
		"legHeader": "Leg",
		"athlete": "Athlete",
		"pick": "Choose an athlete",
		"takeOff": "Take-off",
		"legTime": "Leg time",
		"running": "Running",
		"total": "Legs add up to {{total}}.",
		"mismatch": "Legs add up to {{total}}, but the time is {{final}}.",
		"edit": "Edit line-up",
		"save": "Save line-up",
		"saved": "Line-up saved",
		"cancel": "Cancel",
		"rosterLoading": "Loading the team roster…",
		"rosterError": "The team roster could not be loaded.",
		"noLineup": "No line-up yet.",
		"repeat": "Leg {{leg}}: this athlete already has another leg.",
		"splitWithoutMember": "Leg {{leg}}: choose the athlete first.",
		"conflict": "Someone else changed this team's slot. Keep your line-up or take theirs.",
		"reserve": "Reserve"
	},
	"actionError": {
		"stale": "Someone else changed this first. It has been reloaded; enter your change again.",
		"official": "The meet is official. To make changes, change the Meet status (you will be asked to confirm).",
		"locked": "The medal desk has locked this event.",
		"lineup_strangers": "Someone in this line-up is not on the team roster.",
		"validation": "Some values were not accepted.",
		"family_changed": "This meet's result type changed. Reload the meet.",
		"offline": "No answer from the server. Your change is kept here; try again.",
		"forbidden": "Your role cannot make this change.",
		"not_found": "This was not found. It may have been removed.",
		"auth": "Your session ended. Sign in again, then save.",
		"unknown": "The change was not saved. Try again."
	},
	"empty": {
		"title": "No one on the start list yet",
		"body": "Add competitors in the start list editor."
	},
	"qualShort": {
		"BY_PLACE": "Q",
		"BY_PERFORMANCE": "q",
		"BY_DECISION": "qR",
		"RESERVE": "R"
	},
	"medal": {
		"GOLD": "Gold",
		"SILVER": "Silver",
		"BRONZE": "Bronze"
	},
	"source": {
		"timing": "Timing",
		"override": "Override",
		"manual": "Manual",
		"timingHint": "Written by the timing system. Press Override to type over it.",
		"overrideHint": "Changed by an operator over the timing system. The feed no longer writes this row.",
		"manualHint": "Typed by an operator.",
		"overrideAction": "Override",
		"relock": "Cancel"
	},
	"simulator": {
		"title": "Timing simulator",
		"body": "Development only. Sends what a pool's timing system would send for this heat, through the real feed.",
		"noLanes": "No lanes to time yet. Fill the start list with lanes first.",
		"splits": "50 m touches",
		"finish": "Finish",
		"lane": "Lane",
		"softTouch": "Soft touch",
		"saved_one": "Accepted: {{count}} row written.",
		"saved_other": "Accepted: {{count}} rows written.",
		"dropped": "Dropped: the feed already had a later message.",
		"badSplits": "Bad splits",
		"unknownLane": "Unknown lane"
	},
	"feed": {
		"title": "Timing feed",
		"skipped_one": "{{count}} lane not applied",
		"skipped_other": "{{count}} lanes not applied",
		"allApplied": "Every lane applied",
		"notes": "Worth a look",
		"lastMessage": "Last message {{time}}",
		"device": "From {{device}}",
		"race": "Race: {{problem}}",
		"lane": "Lane {{lane}}: {{problem}}",
		"rowMarker": "Timing feed: {{reasons}}",
		"problem": {
			"RACE_MISMATCH": "The message is for another race. Nothing was written.",
			"UNKNOWN_LANE": "no competitor in this lane.",
			"DUPLICATE_LANE": "sent twice in one message.",
			"AMBIGUOUS_LANE": "two competitors share this lane.",
			"EMPTY_SLOT": "the lane waits for its competitor.",
			"MANUAL_OVERRIDE": "an operator typed this result, so the feed keeps off it.",
			"SPLITS_UNKEYED": "the stored splits have no distances, so they were kept.",
			"SPLIT_BEYOND_DISTANCE": "a split past the race distance.",
			"SPLITS_OUT_OF_ORDER": "the splits do not rise with distance.",
			"FINISH_SPLIT_MISMATCH": "the touch at the wall differs from the finish.",
			"FINISH_BEFORE_SPLIT": "the finish is not later than the last split.",
			"STATUS_WITH_FINISH": "DNS with a finish time.",
			"IRM_DIFFERS": "the timing system's mark differs from the row's, which was kept.",
			"PLACE_MISMATCH": "the timing system's place differs from the rank."
		}
	},
	"bench": {
		"title": "Pool timer",
		"none": "No pool timer has sent a race yet.",
		"listError": "Could not load the pool timers. Retrying.",
		"running": "Running",
		"stopped": "Stopped",
		"resets_one": "Reset {{count}} time",
		"resets_other": "Reset {{count}} times",
		"apply": "Apply timer results",
		"applyNotNow": "Timer results can be applied while the meet is at Start list or Live.",
		"noSwimmer": "Timer lanes with no swimmer: {{lanes}}",
		"unmapped": "Timer lanes not matched to a pool lane yet (timer numbering): {{lanes}}",
		"skippedLane": "Lane {{lane}} not sent: {{problem}}",
		"skippedTimerLane": "Timer lane {{lane}} not sent: {{problem}}",
		"skip": {
			"no_pool_lane": "the timer has not matched it to a pool lane.",
			"suspect": "the timer doubts this reading. Enter it by hand."
		},
		"error": {
			"empty": "The timer has no lane that can be applied yet.",
			"mismatch": "The timer timed a race of another distance. Nothing was applied.",
			"noDistance": "This race has no distance. Set it in Settings, then apply again."
		},
		"mismatch": "The timer is on a {{timer}} m race; this race is {{race}} m. Set the timer to this race, then apply.",
		"suspect": "The timer doubts this lane: {{reasons}}",
		"suspectNoReason": "no reason given",
		"splitAt": "{{distance}} m",
		"place": "P{{place}}",
		"track": {
			"title": "Track timer",
			"none": "No track timer has sent a race yet.",
			"listError": "Could not load the track timers. Retrying.",
			"noAthlete": "Timer lanes with no athlete: {{lanes}}",
			"noWind": "no reading",
			"useWind": "Use timer wind",
			"reaction": "Reaction {{time}}"
		},
		"waiting": "Racing: {{done}} of {{lanes}} lanes finished. Results save at the finish.",
		"waitingStart": "Waiting for the race to finish. Results save at the finish.",
		"finished": "Race finished",
		"early_one": "{{count}} lane has not finished yet. Its splits will be saved without a final time; enter its time by hand.",
		"early_other": "{{count}} lanes have not finished yet. Their splits will be saved without a final time; enter their times by hand.",
		"liveSplit": "From the timer at {{distance}} m, not saved yet. It saves with \"Apply timer results\" at the finish.",
		"liveFinish": "From the timer, not saved yet. It saves with \"Apply timer results\"."
	}
}
